'use strict';

angular.module('shiftTraderApp')
  .controller('ManageWorkPeriodsCtrl', function ($rootScope, $scope, $http, $uibModal, $location, ServerUrls,
                                                 WorkPeriods, WorkPeriodStore, ShiftTemplates, Session, $timeout,
                                                 TimeService, me, allWorkPeriods, allPositions, theDate, $interval,
                                                 org, saViewShiftHourWidthInt, Users, Shifts, $q,
                                                 saViewShiftRowHeightInt, InternalAnalyticsService, $uibModalStack,
                                                 MWPHighlightService, ShepherdTourService, EventStreamsService,
                                                 MWPCompositeAvailabilityService, zIndexManageWorkPeriodsMax,
                                                 UserPermissionsService, NotesOverlayContextService, NotesStore,
                                                 UserPayRates, toastr, GlobalRxFeed) {

    // if the user re-inits this controller, let's just clear the availability cache
    MWPCompositeAvailabilityService.invalidateCache();
    var mwpUpdateStream = EventStreamsService.getStream(EventStreamsService.names.mwpUpdates);
    var mwpCollapseStream = EventStreamsService.getStream(EventStreamsService.names.mwpCollapseChange);

    $scope.me = me;
    $scope.allWorkPeriods = allWorkPeriods;
    $scope.allPositions = lodash.map(allPositions, function(pos) {
      pos._collapsed = false;
      return pos;
    });
    $scope.org = org;

    UserPayRates.getAll({organization_id: $scope.org.id})
      .then(function(uprs) {
        console.log(uprs);
      }, function(response) {
        console.log('error', response);
      });

    $scope.state = {
      rawPermissions: null,
      derivedPermissions: null,
      rawPermissionsDefers: [],
      selectedTemplate: { id: -1, name: 'Loading...'},
      notes: {}
    };

    function loadShiftTemplates() {
      ShiftTemplates.getAll({
        archived: false,
        offset: 0
      })
        .then(function(unarchivedTemplates) {
          $scope.allShiftTemplates = unarchivedTemplates;
          initShiftTemplates();
          inspectWorkPeriodsInShiftTemplate();
        }, function() {

        });
    }


    var permissionsToLookUp = [
      'work_periods.publish',
      'work_periods.create',
      'work_periods.update',
      'work_periods.change_published',
      'work_periods.set_published_inactive',
      'work_periods.set_unpublished_inactive',
      'work_periods.split_published',
      'work_periods.split_unpublished',
      'users.view_actual_employee_wages',
      'users.view_estimated_labor_cost',
      'projections.create',
      'shift_templates.view'
    ];

    function processRawPermissions() {
      var rawPerms = $scope.state.rawPermissions;

      $scope.state.derivedPermissions = {
        canCreateWorkPeriods: rawPerms['work_periods.create'],
        canSmartSchedule: rawPerms['work_periods.create'],
        canApplyTemplates: rawPerms['work_periods.create'] && rawPerms['shift_templates.view'],
        canViewTemplates: rawPerms['shift_templates.view'],
        canSetProjections: rawPerms['projections.create']
      };

      lodash.forEach($scope.state.rawPermissionsDefers, function(defer) {
        defer.resolve($scope.state.rawPermissions);
      });

      if ($scope.state.derivedPermissions.canViewTemplates) {
        loadShiftTemplates();
      }
    }

    UserPermissionsService.getCanDict(permissionsToLookUp, $scope.org.id)
      .then(function(dikt) {
        $scope.state.rawPermissions = dikt;

        processRawPermissions();
      }, function() {

      });

    $scope.getRawPermissions = function() {
      var deferred = $q.defer();

      if (!lodash.isNull($scope.state.rawPermissions)) {
        deferred.resolve($scope.state.rawPermissions);
      } else {
        $scope.state.rawPermissionsDefers.push(deferred);
      }

      return deferred.promise;
    };

    $scope.allDepartments = $scope.org.departments;
    var posZIndexCurrent = zIndexManageWorkPeriodsMax;
    lodash.forEach($scope.allDepartments, function(dept) {
      if (!lodash.has(dept, 'positions')) {
        dept.positions = [];
      }
      dept.positions = lodash.filter($scope.allPositions, {department_id: dept.id});

      // set the starting zIndex for each position
      dept._zIndexStart = posZIndexCurrent;
      posZIndexCurrent -= 10;
      lodash.forEach(dept.positions, function(pos) {
        pos._zIndexStart = posZIndexCurrent;
        posZIndexCurrent -= 50;
      });

      dept.positionsToShow = lodash.filter(dept.positions, {active: true});
      dept._collapsed = false;
    });

    $scope.modalOpenWaitFlags = {
      review: false,
      allocations: false
    };


    $scope.userDataLoaded = false;
    Users.getAll({status: 'active'})
        .then(function(usersData) {
          $scope.allUsers = lodash.filter(usersData, function(usr) {
            return usr.$curMemb().active > 0;
          });
          $scope.userDataLoaded = true;

          if ($scope.modalOpenWaitFlags.review) {
            $scope.openWeekReviewModal();
          }

          if ($scope.modalOpenWaitFlags.allocations) {
            $scope.openEmployeeListModal();
          }

          $scope.modalOpenWaitFlags.review = false;
          $scope.modalOpenWaitFlags.allocations = false;
        });

    $scope.nowInStoreTime = TimeService.getNowInStoreTime();
    $scope.dateToday = TimeService.getBeginningOfDayFromDate(moment.utc());
    $scope.scrollTheWindow = true;
    $scope.loadAllDone = false;
    $scope.currentDate = theDate;

    NotesOverlayContextService.setDateContext($scope.currentDate);

    function loadNotesOnPosition() {
      NotesStore.getNotesForObjWithDate('Position', null, TimeService.getDayTwixFromDate($scope.currentDate))
        .then(function(notes) {
          lodash.each($scope.allPositions, function(pos) {
            $scope.state.notes[pos.id] = lodash.filter(notes, function(note) {
              return lodash.some(note.notes_relations, function(rel) {
                return rel.obj === 'Position' && rel.obj_id == pos.id;
              });
            });
          });
        });
    }

    Session.isFeatureEnabled('notes')
      .then(function(res) {
        if (res) {
          loadNotesOnPosition();
        }
      }, function(response) {

      });

    var lastDate = $scope.currentDate;
    $scope.todayAfterCurrent = $scope.dateToday.isAfter($scope.currentDate);
    $scope.forceUpdate = false;
    $scope.drawEditModeState = false;

    $scope.smartSchedulingAvailable = !moment($scope.dateToday).subtract(1, 'days').isAfter($scope.currentDate);
    // attempt to load previously set collapsed states for departments and positions
    $scope.openStates = Session.getManageWorkPeriodsCollapseStates();
    if (!lodash.isUndefined($scope.openStates) && !lodash.isNull($scope.openStates)) {
      if (!lodash.isUndefined($scope.openStates.departments)) {
        var idx;
        lodash.forEach($scope.openStates.departments, function(val, dept_id) {
          idx = lodash.findIndex($scope.allDepartments, {id: parseInt(dept_id)});
          if (idx > -1) {
            $scope.allDepartments[idx]._collapsed = val;
          }
        });
      }

      if (!lodash.isUndefined($scope.openStates.positions)) {
        var idx;
        lodash.forEach($scope.openStates.positions, function(val, pos_id) {
          idx = lodash.findIndex($scope.allPositions, {id: parseInt(pos_id)});
          if (idx > -1) {
            $scope.allPositions[idx]._collapsed = val;
          }
        });
      }
    }

    mwpCollapseStream.push('all', true);

    $scope.measuringTapeInfo = [
      {
        label: '6p'
      },
      {
        label: '7'
      },
      {
        label: '8'
      },
      {
        label: '9'
      },
      {
        label: '10'
      },
      {
        label: '11'
      },
      {
        label: '12a'
      },
      {
        label: 1
      },
      {
        label: 2
      },
      {
        label: 3
      },
      {
        label: 4
      },
      {
        label: 5
      },
      {
        label: 6
      },
      {
        label: '7a'
      },
      {
        label: 8
      },
      {
        label: 9
      },
      {
        label: 10
      },
      {
        label: 11
      },
      {
        label: '12p'
      },
      {
        label: '1'
      },
      {
        label: '2'
      },
      {
        label: '3'
      },
      {
        label: '4'
      },
      {
        label: '5'
      },
      {
        label: '6p'
      },
      {
        label: 7
      },
      {
        label: 8
      },
      {
        label: 9
      },
      {
        label: 10
      },
      {
        label: 11
      },
      {
        label: '12a'
      },
      {
        label: 1
      },
      {
        label: 2
      },
      {
        label: 3
      },
      {
        label: 4
      },
      {
        label: 5
      }
    ];

    lodash.forEach($scope.measuringTapeInfo, function(mti, idx) {
      mti.left = idx * saViewShiftHourWidthInt + 'px';
    });

    $scope.positionCollapsedHeight = saViewShiftRowHeightInt;

    //$scope.smartSchedulingAvailable = false;
    $scope.activeTemplateCompletelyFilled = true;

    if (!$rootScope.isIpad) {
      $('.work_period_container_scroller').dragOn({cursor: null, easing: true, exclusion:{input:'',select:'',id:'#gmap,#map-canvas,.modal,.modal-backdrop,.intelli_view_shift,.drag_handle,[data-overflow=no-dragon],a > :not(img)'},holdEvents : 'mousedown', dragEvents : 'mousemove', releaseEvents : 'mouseup', wheelEvents : 'none', leaveEvents : 'mouseleave'});
    }


    $timeout(function() {
      // track the time_bar X scroll position to the calendar_area and vice versa
      $('#time_bar').scroll(function () {
        $('#calendar_area').scrollLeft($('#time_bar').scrollLeft());
      });
      $('#calendar_area').scroll(function () {
        $('#time_bar').scrollLeft($('#calendar_area').scrollLeft());
      });
    }, 700);


    var initShiftTemplates = function() {
      $scope.shiftTemplateOptions = [{id: -1, name: 'Apply a Template'}];
      $scope.shiftTemplateOptions.push.apply($scope.shiftTemplateOptions,
        lodash.filter($scope.allShiftTemplates, function(st) {
          st.icon = false;
          return st.active && !st.archived;
        }));
    };

    // initialize the shift templates in the dropdown array

    $scope.removeTemplate = function() {
      // merely set the state.selectedTemplate variable back to the -1 id
      $scope.state.selectedTemplate = {id: -1, name: 'Apply a Template'};
    };
    $scope.removeTemplate();

    var calcWorkPeriodsOfTheDay = function() {
      var startOfDayTime = moment($scope.currentDate).subtract(6,'hours');//.unix();
      var endOfDayTime = moment($scope.currentDate).add(30, 'hours');//.unix();
      var currentViewWindow = startOfDayTime.twix(endOfDayTime);
      //console.log(currentViewWindow.format());
      return lodash.filter($scope.allWorkPeriods, function (workPeriod) {
        return currentViewWindow.intersection(workPeriod.range_twix).length('seconds') > 0 && workPeriod.active;
      });
    };

    var getCurrentDayWindow = function() {
      var adjustedCurrentDate = moment($scope.currentDate).add(Session.getWorkDayStartHour(), 'hours');
      return moment(adjustedCurrentDate).twix(moment(adjustedCurrentDate).add(24, 'hours'));
    };


    function inspectWorkPeriodsInShiftTemplate() {
      var currentDayWindow = getCurrentDayWindow();

      // Figure out if a workPeriod is related to a shiftTemplate
      lodash.forEach($scope.workPeriodsOfTheDay, function(wp) {
        // the workPeriod must start after or on the currentDate to be classified as a part of a template
        if (!lodash.isUndefined(wp.shift_id) && !lodash.isNull(wp.shift_id) && ((wp.start_time.isAfter(currentDayWindow.start) || wp.start_time.isSame(currentDayWindow.start)) && wp.start_time.isBefore(currentDayWindow.end))) {
          // shift_id is a real value so lets find the template
          $scope.shiftsWithWorkPeriods.push(wp.shift_id);

          // loop over all shift_templates looking for a shift_id match
          var matchingTemplate = lodash.find($scope.shiftTemplateOptions, function(st) {
            return lodash.some(st.shifts, function(shift) {
              return shift.id === wp.shift_id;
            });
          });
          if (!lodash.isUndefined(matchingTemplate)) {
            wp._shiftTemplateId = matchingTemplate.id;
            //mutating state of $scope.shiftTemplateOptions here!! Must be cleared when loadCurrentDateWeek is executed
            matchingTemplate.icon = 'icon-asterisk';
          }
        } else {
          wp._shiftTemplateId = null;
        }
      });
    }

    var loadCurrentDateWeek = function() {
      //window.logTime(('loadCurrentDateWeek start');
      //console.log('entering: loadCurrentDateWeek');
      var weekTwix = TimeService.getWeekTwixFromMoment($scope.currentDate, 1, 0);
      return WorkPeriodStore.getWorkPeriodsBetween(weekTwix.start, weekTwix.end)
        .then(function(workPeriods) {
          //window.logTime(('loadCurrentDateWeek WorkPeriodStore returned');
          $scope.allWorkPeriods = workPeriods;
          //console.log('numWorkPeriods retrieved:', $scope.allWorkPeriods.length);
          var positionIds = lodash(workPeriods).map('position_id').uniq().value();

          $scope.positionsToShow = [];
          lodash.forEach($scope.allDepartments, function(dept) {
            //console.log(dept.name, dept.positionsToShow.length, dept.positions.length);
            dept.positionsToShow = lodash.filter(dept.positions, {active: true});
          });

          lodash.forEach($scope.allPositions, function(pos) {
            if (pos.active) {
              $scope.positionsToShow.push(pos);
            } else if (lodash.includes(positionIds, pos.id)) {
              $scope.positionsToShow.push(pos);
              var deptIdx = lodash.findIndex($scope.allDepartments, {id: pos.department_id});
              if (deptIdx > -1 && !lodash.some($scope.allDepartments[deptIdx].positionsToShow, function(p) {
                return p.id === pos.id;
              })) {
                $scope.allDepartments[deptIdx].positionsToShow.push(pos);
              }
            }
          });

          $scope.positionsToShow = lodash.filter($scope.allPositions, function(pos) {
            return pos.active || lodash.includes(positionIds, pos.id);
          });

          $scope.shiftsWithWorkPeriods = [];

          // Must re-init shift templates because I mutate state below when figuring out the template assignments
          initShiftTemplates();
          //Tell the footer what the date is and that we're loaded (WorkPeriodStore has been populated)
          $rootScope.$broadcast('sa:manageWorkPeriod:WorkPeriodStoreUpdated', $scope.currentDate);

          lastDate = moment($scope.currentDate);
          $scope.workPeriodsOfTheDay = calcWorkPeriodsOfTheDay();

          inspectWorkPeriodsInShiftTemplate();

          var scrollPx = 12 * saViewShiftHourWidthInt;
          if ($scope.workPeriodsOfTheDay.length) {
            $scope.firstWorkPeriodOfTheDay = lodash.sortBy(getTheDaysWorkPeriods(), 'start_time')[0];

            if ($scope.scrollTheWindow) {
              if ($scope.firstWorkPeriodOfTheDay) {
                scrollPx = ($scope.firstWorkPeriodOfTheDay.start_time.hours() - 1) * saViewShiftHourWidthInt + 6 * saViewShiftHourWidthInt;
              }
            }
          }

          if ($scope.scrollTheWindow) {
            $scope.scrollTheWindow = false;
            $timeout(function() {
              $('.measuring-tape-container').animate({scrollLeft: scrollPx}, 400);
            }, 300);

          }

          $scope.workPeriodsByPositionIndex = [];
          lodash.forEach($scope.positionsToShow, function() {
            $scope.workPeriodsByPositionIndex.push([]);
          });

          $scope.shiftsAndWorkPeriodsByPositionIndex = [];
          lodash.forEach($scope.positionsToShow, function() {
            $scope.shiftsAndWorkPeriodsByPositionIndex.push([]);
          });

          $scope.activeShiftTemplate = lodash.find($scope.allShiftTemplates, function(st) {
            return st.id === $scope.state.selectedTemplate.id;
          });

          if ($scope.activeShiftTemplate && $scope.activeShiftTemplate.id >= 0) {
            $scope.shiftsInActiveTemplate = lodash.map($scope.activeShiftTemplate.shifts, function(s) {
              s.$setDateForTimeCalcs($scope.currentDate);
              return s;
            });
          } else {
            $scope.shiftsInActiveTemplate = [];
          }

          lodash.forEach($scope.workPeriodsOfTheDay, function(wp) {
            var idz = lodash.findIndex($scope.positionsToShow, {id: wp.position.id});


            $scope.workPeriodsByPositionIndex[idz].push(wp);
            $scope.shiftsAndWorkPeriodsByPositionIndex[idz].push(wp);
          });

          lodash.forEach($scope.shiftsInActiveTemplate, function(shift) {
            var idz;
            if (!lodash.includes($scope.shiftsWithWorkPeriods, shift.id)) {
              idz = lodash.findIndex($scope.positionsToShow, {id: shift.position_id});

              // if the position is active then show it, otherwise don't!
              if ($scope.positionsToShow[idz] && $scope.positionsToShow[idz].active) {
                //console.log('adding it in', shift.id);
                $scope.shiftsAndWorkPeriodsByPositionIndex[idz].push(shift);
              }
            }
          });

          var shiftsWithWorkPeriodsInActiveTemplate = $scope.state.selectedTemplate.id > -1 ? lodash.filter($scope.shiftsWithWorkPeriods, function(s) {
            return lodash.some($scope.activeShiftTemplate.shifts, function(shift) {
              return shift.id === s;
            });
          }) : [];

          $scope.activeTemplateCompletelyFilled = ($scope.state.selectedTemplate.id > -1 ? shiftsWithWorkPeriodsInActiveTemplate.length >= $scope.shiftsInActiveTemplate.length : true) &&
            (lodash.every(getTheDaysWorkPeriods(false, true), function(wp) { return wp.$isAssigned(); }));

          $scope.loadAllDone = true;
          //console.log('BROADCASTING: redrawPositionBar');
          //window.logTime(('loadCurrentDateWeek before redrawPositionBar');
          $scope.$broadcast('redrawPositionBar', true);

          mwpUpdateStream.push('dataUpdate', true);

          //window.logTime(('loadCurrentDateWeek after redrawPositionBar');
        });
    };

    loadCurrentDateWeek();

    $scope.$watch('forceUpdate', function(newVal, oldVal) {
      //console.log('$watch: forceUpdate', newVal, oldVal);
      if ($scope.loadAllDone && newVal !== oldVal) {
        //console.log('WATCH FIRED: forceUpdate');
        loadCurrentDateWeek();
      }
    }, true);

    $scope.$watch('state.selectedTemplate', function(newVal, oldVal) {
      //console.log('$watch: state.selectedTemplate', newVal.id, oldVal.id, $scope.loadAllDone);
      if ($scope.loadAllDone && newVal.id !== oldVal.id) {
        //console.log('WATCH FIRED: state.selectedTemplate');
        loadCurrentDateWeek();
        $rootScope.$broadcast('sa:manageWorkPeriod:selectedTemplateChange', $scope.state.selectedTemplate);
      }

    }, true);

    $rootScope.$broadcast('sa:manageWorkPeriod:selectedTemplateChange', $scope.state.selectedTemplate);

    $scope.$on('sa:manageWorkPeriod:dateChange', function(event, newDate) {
      // window.logTime(event.name + ' $on MWP ' + (newDate && newDate.format() || ''));
      // console.log('$ON: sa:manageWorkPeriod:dateChange', newDate);
      $scope.currentDate = newDate;
      $scope.scrollTheWindow = true;
      $scope.dateToday = TimeService.getBeginningOfDayFromDate(moment.utc());
      $scope.todayAfterCurrent = $scope.dateToday.isAfter($scope.currentDate);
      $scope.smartSchedulingAvailable = !moment($scope.dateToday).subtract(1, 'days').isAfter($scope.currentDate);

      NotesOverlayContextService.setDateContext($scope.currentDate);

      if ($scope.todayAfterCurrent && $scope.drawEditModeState) {
        $scope.exitEditDrawMode();
      }

      loadCurrentDateWeek();

      getCompositeAvailability();

      $scope.$broadcast('sa:wideWorkPeriodView:dateChange', $scope.currentDate);
    });

    var getCompositeAvailability = function() {
      // when dateChange occurs, need to trigger a composite availability load
      var weekTwix = TimeService.getWeekTwixFromMoment($scope.currentDate, 1, 0);

      $scope.compositeAvailabilityLoaded = false;

      MWPCompositeAvailabilityService.getCompositeAvailability(weekTwix.start, weekTwix.end)
        .then(function(data) {
          if (data) {
            $scope.compositeAvailability = data;

            var applyAvailability = function() {
              lodash.forEach($scope.allUsers, function(u, idx) {
                $scope.allUsers[idx].$mergeInAvailability($scope.compositeAvailability);
              });

              $scope.compositeAvailabilityLoaded = true;
            };

            if ($scope.userDataLoaded) {
              applyAvailability();
            } else {
              var intvl = $interval(function() {
                //console.log('user load check interval');
                if ($scope.userDataLoaded) {
                  applyAvailability();
                  $interval.cancel(intvl);
                }


              }, 100);
            }
          }
        });
    };

    getCompositeAvailability();

    $scope.$on('inactivateShift', function (event, id) {
      event.stopPropagation();
      var shift = lodash.find($scope.allWorkPeriods, {id: id});
      shift.$update({active: false}).then(function (wp) {
        WorkPeriodStore.replaceById(wp);
        $scope.scrollTheWindow = false;
        loadCurrentDateWeek();
      });
    });

    $scope.enterEditDrawMode = function() {
      if (!$scope.todayAfterCurrent) {
        $rootScope.$broadcast('sa:manageWorkPeriods:setEditDrawMode', true);
        $scope.drawEditModeState = true;
      }
    };

    $scope.exitEditDrawMode = function() {
      $rootScope.$broadcast('sa:manageWorkPeriods:setEditDrawMode', false);
      $scope.drawEditModeState = false;
    };




    var openEditShiftModal = function(wp) {
      var modalInstance = $uibModal.open({
        size: 'create-work-period',
        keyboard: false,
        backdrop: 'static',
        templateUrl: 'views/createWorkPeriodDialog2.html',
        controller: 'CreateWorkPeriodDialogCtrl',
        resolve: {
          params: function () {
            return {
              workPeriod: wp,
              currentDate: $scope.currentDate,
              adjustedCurrentDate: getCurrentDayWindow(),
              allPositions: $scope.allPositions,
              allDepartments: $scope.allDepartments,
              allUsers: $scope.allUsers,
              allWorkPeriods: $scope.allWorkPeriods,
              me: $scope.me,
              mode: 'edit'
            };
          }
        }
      });

      modalInstance.result.then(function(results) {
        if (angular.isDefined(results)) {
          $timeout(function() {
            lodash.forEach(results, function(resultWp, idz) {
              var idxToReplace = lodash.findIndex($scope.allWorkPeriods, function(wp) {
                return wp.id === resultWp.id;
              });
              if (idxToReplace > -1) {
                WorkPeriodStore.removeByWorkPeriod($scope.allWorkPeriods[idxToReplace]);
              } else {
                console.log('could not find matching workPeriod');
              }
              WorkPeriodStore.addWorkPeriod(resultWp)
                .then(function() {
                  //change the view to the day that we changed the shift to
                  if (idz === (results.length -1)) {
                    $rootScope.$broadcast('sa:manageWorkPeriod:WorkPeriodStoreUpdated', $scope.currentDate);
                    $scope.scrollTheWindow = true;
                    if (resultWp.start_time.dayOfYear() !== $scope.currentDate.dayOfYear()) {
                      $rootScope.$broadcast('sa:manageWorkPeriod:dateChangeRequest', {moment:TimeService.getBeginningOfDayFromDate(resultWp.start_time)});
                    }
                    //update the workPeriod in $scope.allWorkPeriods
                    console.log('FORCEUPDATE TOGGLE: edit cWPD');
                    $scope.forceUpdate = !$scope.forceUpdate;
                  }
                });

            });

          }, 0);
        }
      });
    };

    var openDuplicateShiftModal = function(wp) {
      var modalInstance = $uibModal.open({
        size: 'create-work-period',
        keyboard: false,
        backdrop: 'static',
        templateUrl: 'views/createWorkPeriodDialog2.html',
        controller: 'CreateWorkPeriodDialogCtrl',
        resolve: {
          params: function () {
            return {
              workPeriod: wp,
              currentDate: $scope.currentDate,
              adjustedCurrentDate: getCurrentDayWindow(),
              allPositions: $scope.allPositions,
              allDepartments: $scope.allDepartments,
              allUsers: $scope.allUsers,
              allWorkPeriods: $scope.allWorkPeriods,
              me: $scope.me,
              mode: 'duplicate'
            };
          }
        }
      });

      modalInstance.result.then(function(result) {
        if (angular.isDefined(result)) {
          WorkPeriodStore.addWorkPeriods(result)
            .then(function() {
              $rootScope.$broadcast('sa:manageWorkPeriod:WorkPeriodStoreUpdated', $scope.currentDate);
              $scope.scrollTheWindow = true;
              if (result[0].start_time.dayOfYear() !== $scope.currentDate.dayOfYear()) {
                $rootScope.$broadcast('sa:manageWorkPeriod:dateChangeRequest', {moment:TimeService.getBeginningOfDayFromDate(result[0].start_time)});
              }
              $scope.forceUpdate = !$scope.forceUpdate;
              //change the view to the day that we changed the shift to
              console.log('FORCEUPDATE TOGGLE: duplicate cWPD');
            });
        } else {
          console.log('could not find matching workPeriod');
        }

        //update the workPeriod in $scope.allWorkPeriods
      });
    };

    $scope.$on('editShift', function(event, wp) {
      openEditShiftModal(wp);
    });

    $scope.$on('splitShift', function(event, wp) {
      openSplitShiftModal(wp);
    });

    $scope.$on('duplicateShift', function(event, wp) {
      openDuplicateShiftModal(wp);
    });

    var openSplitShiftModal = function(wp) {
      var modalInstance = $uibModal.open({
        size: 'md2',
        keyboard: false,
        backdrop: 'static',
        templateUrl: 'views/splitShiftModal.html',
        controller: 'SplitShiftModalCtrl',
        resolve: {
          params: function() {
            return {
              me: me,
              org: $scope.org,
              currentDate: $scope.currentDate,
              workPeriod: wp
            };
          }
        }
      });
      modalInstance.result.then(function(resultingWorkPeriods) {
        console.log('closed split shift modal', resultingWorkPeriods);
        $rootScope.$broadcast('sa:manageWorkPeriod:WorkPeriodStoreUpdated', $scope.currentDate);
        $scope.scrollTheWindow = false;
        $scope.forceUpdate = !$scope.forceUpdate;
      }, function() {
        // don't do anything. They cancelled.
      });
    };

    $scope.openCreateWorkPeriodDialog = function(pos) {
      if(!$scope.todayAfterCurrent && $scope.userDataLoaded && pos.active && $scope.state.derivedPermissions.canCreateWorkPeriods) {
        var modalInstance = $uibModal.open({
          size: 'create-work-period',
          keyboard: false,
          backdrop: 'static',
          templateUrl: 'views/createWorkPeriodDialog2.html',
          controller: 'CreateWorkPeriodDialogCtrl',
          resolve: {
            params: function () {
              return {
                position: pos,
                currentDate: $scope.currentDate,
                adjustedCurrentDate: getCurrentDayWindow(),
                allPositions: $scope.allPositions,
                allDepartments: $scope.allDepartments,
                allUsers: $scope.allUsers,
                allWorkPeriods: $scope.allWorkPeriods,
                me: $scope.me,
                mode: 'create'
              };
            }
          }
        });

        ShepherdTourService.triggerEvent('createWorkPeriodOpened');

        modalInstance.result.then(function (result) {
          ShepherdTourService.triggerEvent('createWorkPeriodClosed');
          if ( angular.isDefined(result) ) {
            if (result.length > 0) {
              //$scope.allWorkPeriods.push.apply($scope.allWorkPeriods, result);
              WorkPeriodStore.addWorkPeriods(result)
                .then(function() {
                  $rootScope.$broadcast('sa:manageWorkPeriod:WorkPeriodStoreUpdated', $scope.currentDate);
                  $scope.scrollTheWindow = true;
                  if (result[0].start_time.dayOfYear() !== $scope.currentDate.dayOfYear()) {
                    $rootScope.$broadcast('sa:manageWorkPeriod:dateChangeRequest', {moment:TimeService.getBeginningOfDayFromDate(result[0].start_time)});
                  }
                  $scope.forceUpdate = !$scope.forceUpdate;
                });
            } else {
              console.log('No work periods passed out of createWorkPeriodDialog.');
            }
          }
        }, function(reason) {
          ShepherdTourService.triggerEvent('createWorkPeriodClosed');
          console.log('createWorkPeriodDialog closed for reason ' + reason);
        });
      }
    };

    $scope.$on('publishSingleWorkPeriod', function(event, wp) {
      var data = {
        organization_id: wp.organization.id,
        id: wp.id,
        published_by_id: $scope.me.id
      };

      $http.put(ServerUrls.current.railsApi + 'work_periods/' + wp.id, data).then(function (response) {
        //console.log('Publish WorkPeriod');
        //console.log(response.data);
        WorkPeriodStore.mergeById(WorkPeriods.initWithData(response.data));

        $scope.forceUpdate = !$scope.forceUpdate;
        toastr.success('Shift was published and the employee notified!', 'Success');
        $rootScope.$broadcast('sa:manageWorkPeriod:WorkPeriodStoreUpdated', $scope.currentDate);


        InternalAnalyticsService.captureAnalytic('publish_work_periods:single', {
          _v: 1,
          _d: {
            num_published: 1,
            first_work_period_start: wp.start_time.format(),
            last_work_period_start: wp.start_time.format(),
            position_ids: [wp.position_id],
            department_ids: lodash($scope.allDepartments).filter(function(dept) {
              return lodash.some(dept.positions, function(pos) {
                return wp.position_id === pos.id;
              })
            }).map('id').value()
          }
        });

      }, function () {
        toastr.error('Shift was not published. Please try again later.', 'Error');
      });
    });

    $scope.$on('publishDay', function () {
      var workPeriodsByPositionId = {};

      lodash.forEach($scope.allPositions, function(pos) {
        workPeriodsByPositionId[pos.id] = lodash.filter(getTheDaysWorkPeriods(false, true), function(wp) {
          return wp.position_id === pos.id && !wp.$isPublished() && wp.$isAssigned() && wp.active;
        }).length;
      });

      var modalInstance = $uibModal.open({
        size: 'publish',
        keyboard: false,
        backdrop: 'static',
        templateUrl: 'views/modalPublishing.html',
        controller: 'ModalPublishingCtrl',
        resolve: {
          params: function() {
            return {
              me: me,
              org: $scope.org,
              currentDate: $scope.currentDate,
              workPeriodsByPositionId: workPeriodsByPositionId
            };
          }
        }
      });
      modalInstance.result.then(function(positionIds) {
        var adjustedCurrentDate = getCurrentDayWindow();
        var data = {
          organization_id: $scope.allWorkPeriods[0].organization.id, // Session.me.primary_organization.id,
          start_time: adjustedCurrentDate.start.toISOString(),
          end_time: adjustedCurrentDate.end.toISOString(),
          work_period_ids: lodash(getTheDaysWorkPeriods(false, true)).filter(function(wp) {
            return lodash.includes(positionIds, wp.position_id) && wp.$isAssigned() && !wp.$isPublished() && wp.active;
          }).map('id')
        };

        $http.post(ServerUrls.current.railsApi + 'work_periods/bulk_publish', data).then(function (response) {
          var updated_work_periods = lodash.map(response.data, function(wp) {
            return WorkPeriods.initWithData(wp);
          });

          lodash.forEach(updated_work_periods, function(wp) {
            WorkPeriodStore.mergeById(wp);
          });

          $scope.forceUpdate = !$scope.forceUpdate;
          toastr.success(response.data.length + ' shifts published!', 'Success');
          var sortedWorkPeriods = lodash.sortBy(updated_work_periods, function(wp) {
            return wp.start_time.unix();
          });

          InternalAnalyticsService.captureAnalytic('publish_work_periods:day', {
            _v: 1,
            _d: {
              num_published: updated_work_periods.length,
              first_work_period_start: sortedWorkPeriods[0].start_time.format(),
              last_work_period_start: lodash.last(sortedWorkPeriods).start_time.format(),
              position_ids: positionIds,
              department_ids: lodash($scope.allDepartments).filter(function(dept) {
                return lodash.some(dept.positions, function(pos) {
                  return lodash.includes(positionIds, pos.id);
                })
              }).map('id').value()
            }
          });

        });

      }, function() {
        // don't do anything. They cancelled.
      });
    });

    $scope.$on('publishWeek', function () {
      var modalInstance = $uibModal.open({
        size: 'wide',
        keyboard: false,
        backdrop: 'static',
        templateUrl: 'views/modalWeekPublishing.html',
        controller: 'ModalWeekPublishingCtrl',
        resolve: {
          params: function() {
            return {
              me: me,
              org: $scope.org,
              currentDate: $scope.currentDate,
              allPositions: $scope.allPositions
            };
          }
        }
      });
      modalInstance.result.then(function(publishedWorkPeriods) {
        //console.log('publishedWorkPeriods closed');
        //console.log(publishedWorkPeriods);
        $scope.forceUpdate = !$scope.forceUpdate;
      }, function() {
        // don't do anything. They cancelled.
      });
    });

    $scope.openSmartSchedulingTwo = function() {
      var modalInstance = $uibModal.open({
        size: 'smart-sched',
        keyboard: false,
        backdrop: 'static',
        template: '<div class="modal_gradient smart_scheduling_modal base_smart_cwp smart_scheduling">' +
        '<div sa-smart-scheduling="" params="::params" uib-modal-instance="::modalInstance"></div>' +
        '</div>',
        rxName: 'smart-scheduling',
        //templateUrl: 'views/smartScheduling2.html',
        controller: ['$scope', 'params', '$uibModalInstance', function($scope, params, $uibModalInstance) {
          $scope.params = params;
          $scope.modalInstance = $uibModalInstance;
        }],
        //controller: 'SmartSchedulingCtrl',
        resolve: {
          params: function() {
            var activePositionIds = _($scope.allPositions).where({active: true}).pluck('id').value();
            return {
              me: me,
              org: $scope.org,
              allShifts: _($scope.shiftsInActiveTemplate).where(function(s) {
                return lodash.includes(activePositionIds, s.position_id);
              }).map(function(s) {
                var temp = Shifts.initWithData(s);
                if (s.editingTwix && !s.editingTwix.equals(s.range_twix)) {
                  return temp.$modifyTimesWithTwix(s.editingTwix);
                } else {
                  return s.$setDateForTimeCalcs($scope.currentDate);
                }
              }).value(),
              allPositions: lodash.filter($scope.allPositions, {active: true}),
              allUsers: $scope.allUsers,
              currentDate: $scope.currentDate,
              adjustedCurrentDate: getCurrentDayWindow(),
              allDepartments: $scope.allDepartments,
              workPeriods: (function() {
                var adjustedCurrentDate = getCurrentDayWindow();
                // get workPeriods from currentDate (midnight on date being viewed) to 24hrs + the dayStartHour offset
                return lodash.filter($scope.workPeriodsOfTheDay, function(wp) {
                  return (wp.start_time.isAfter(adjustedCurrentDate.start) || wp.start_time.isSame(adjustedCurrentDate.start)) && wp.start_time.isBefore(adjustedCurrentDate.end);
                })
              }())
            };
          }
        }
      });
      modalInstance.result.then(function(result) {
            //console.log('closed duplicate a day modal with result' + result);
            $scope.state.selectedTemplate = {id: -1, name: 'Choose a Template'};
            console.log('FORCEUPDATE TOGGLE: assignShifts modal');

            //make sure the smart scheduling button doesn't show up until we forceUpdate
            $scope.activeTemplateCompletelyFilled = true;
            $scope.forceUpdate = !$scope.forceUpdate;
          },
          function(reason) {
            //make sure the smart scheduling button doesn't show up until we forceUpdate
            $scope.activeTemplateCompletelyFilled = true;
            console.log('dismissed explanation with reason ' + reason);
            $scope.state.selectedTemplate = {id: -1, name: 'Choose a Template'};
            console.log('FORCEUPDATE TOGGLE: assignShifts modal');
            $scope.forceUpdate = !$scope.forceUpdate;
          });
    };


    $scope.openClearDayModal = function() {
      var modalInstance = $uibModal.open({
        size: 'publish',
        keyboard: false,
        backdrop: 'static',
        templateUrl: 'views/modalClearDay.html',
        controller: 'ModalClearDayCtrl',
        resolve: {
          params: function() {
            return {
              me: me,
              org: $scope.org,
              currentDate: $scope.currentDate,
              workPeriods: getTheDaysWorkPeriods(false, true)
            };
          }
        }
      });
      modalInstance.result.then(function(workPeriodIds) {
        var adjustedCurrentDate = getCurrentDayWindow();
        var data = {
          organization_id: $scope.allWorkPeriods[0].organization.id, // Session.me.primary_organization.id,
          start_time: adjustedCurrentDate.start.toISOString(),
          end_time: adjustedCurrentDate.end.toISOString(),
          work_period_ids: workPeriodIds
        };


        $http.post(ServerUrls.current.railsApi + 'work_periods/bulk_remove', data).then(function (response) {
          var updated_work_periods = lodash.map(response.data, function(wp) {
            return WorkPeriods.initWithData(wp);
          });

          lodash.forEach(updated_work_periods, function(wp) {
            WorkPeriodStore.mergeById(wp);
          });

          $scope.forceUpdate = !$scope.forceUpdate;
          toastr.success(response.data.length + ' shifts cleared from ' + adjustedCurrentDate.start.format('MMM D'), 'Success');
          var sortedWorkPeriods = lodash.sortBy(updated_work_periods, function(wp) {
            return wp.start_time.unix();
          });

          InternalAnalyticsService.captureAnalytic('clear_day_work_periods:day', {
            _v: 1,
            _d: {
              num_cleared: updated_work_periods.length,
              first_work_period_start: sortedWorkPeriods[0].start_time.format(),
              last_work_period_start: lodash.last(sortedWorkPeriods).start_time.format(),
              work_period_ids: workPeriodIds
            }
          });

        });

      }, function() {
        // don't do anything. They cancelled.
      });
    };

    var getTheDaysWorkPeriods = function(excludeStart, excludeEnd) {
      var currentWindow = getCurrentDayWindow();
      return lodash.filter($scope.workPeriodsOfTheDay, function(wp) {
        return currentWindow.contains(wp.start_time) &&
            (currentWindow.start.isSame(wp.start_time) ? !excludeStart : true) &&
            (currentWindow.end.isSame(wp.start_time) ? !excludeEnd : true);
      });
    };

    $scope.$on('sa:manageWorkPeriod:openManageTemplatesModal', function() {
      $scope.openManageTemplates();
    });

    $scope.openManageTemplates = function() {
      var modalInstance = $uibModal.open({
        size: 'templates',
        backdrop: 'static',
        templateUrl: 'views/manageTemplatesDialog.html',
        controller: 'ManageTemplatesDialogCtrl',
        resolve: {
          params: function() {
            return {
              me: me,
              allShiftTemplates: $scope.allShiftTemplates,
              org: $scope.org,
              allPositions: $scope.allPositions
            };
          }
        }
      });
      modalInstance.result.then(function(result) {
          console.log('closed manage templates modal with result' + result);
          $scope.allShiftTemplates = result.allTemplates;

          $scope.shiftTemplateOptions = [{id: -1, name: 'Choose a Template'}];
          $scope.shiftTemplateOptions.push.apply($scope.shiftTemplateOptions, lodash.filter($scope.allShiftTemplates, function(st) {return st.active && !st.archived;}));

          if (result.applyTemplateId) {
            $scope.state.selectedTemplate = lodash.find($scope.shiftTemplateOptions, {id: result.applyTemplateId});
          }

          ShepherdTourService.triggerEvent('manageTemplatesClosed');

        },
        function(reason) {
          console.log('dismissed explanation with reason ' + reason);
          ShepherdTourService.triggerEvent('manageTemplatesClosed');
        });
    };


    $scope.$on('sa:manageWorkPeriod:openNewTemplateModal', function() {
      $scope.openCreateTemplate();
    });

    $scope.openCreateTemplate = function() {
      var workPeriodsByPositionId = {};

      lodash.forEach($scope.allPositions, function(pos) {
        workPeriodsByPositionId[pos.id] = lodash.filter(getTheDaysWorkPeriods(false, true), function(wp) {
          return wp.position_id === pos.id && wp.active;
        });
      });
      debugger

      var modalInstance = $uibModal.open({
        size: 'md',
        keyboard: false,
        backdrop: 'static',
        templateUrl: 'views/createTemplatesDialog.html',
        controller: 'CreateTemplatesDialogCtrl',
        resolve: {
          params: function() {
            return {
              me: me,
              org: $scope.org,
              allShiftTemplates: $scope.allShiftTemplates,
              workPeriodsByPositionId: workPeriodsByPositionId
            };
          }
        }
      });
      modalInstance.result.then(function(result) {
            console.log('closed create templates modal with result' + result);
            $scope.allShiftTemplates = result;
            $scope.shiftTemplateOptions = [{id: -1, name: 'Choose a Template'}];
            $scope.shiftTemplateOptions.push.apply($scope.shiftTemplateOptions, lodash.filter($scope.allShiftTemplates, function(st) {return st.active;}));
          },
          function(reason) {
            console.log('dismissed explanation with reason ' + reason);
          });
    };

    $scope.openProjectionsModal = function() {
      var beginningOfWeek = TimeService.getWeekTwixFromMoment($scope.currentDate, 0, 0, false).start.hour(12);
      var dates = lodash.range(7).map(function(num) {
          return moment(beginningOfWeek).add(num, 'days').hour(0);
      });

      var modalInstance = $uibModal.open({
        size: 'wide',
        keyboard: false,
        backdrop: 'static',
        templateUrl: 'views/projectionsModal.html',
        controller: 'ProjectionsCtrl',
        resolve: {
          params: function() {
            return {
              me: me,
              org: $scope.org,
              dates: dates
            };
          },
          initialProjections: ['Projections', function(Projections) {
            return Projections.getAll({
              organization_id: $scope.org.id,
              start_date: dates[0].format('YYYY-MM-DD'),
              end_date: dates[6].format('YYYY-MM-DD'),
              active: true
            })
          }]
        }
      });
      modalInstance.result.then(function(result) {
          $rootScope.$broadcast('sa:manageWorkPeriod:projectionsUpdated');
        },
        function(reason) {
          console.log('dismissed explanation with reason ', reason);
        });
    };


    $scope.openWeekReviewModal = function() {
      if (!$scope.userDataLoaded) {
        $scope.modalOpenWaitFlags.review = true;
      } else {
        var workPeriodTimeframe = TimeService.getWeekTwixFromMoment($scope.currentDate, 1, 0, true);
        var businessWeek = TimeService.getWeekTwixFromMoment($scope.currentDate, 0, 0, true);
        var dates = lodash.range(7).map(function(num) {
          return moment(businessWeek.start).add(num, 'days');
        });

        var modalInstance = $uibModal.open({
          size: 'wide',
          keyboard: false,
          backdrop: 'static',
          templateUrl: 'views/reviewWeekScheduleModal.html',
          controller: 'ReviewWeekScheduleCtrl',
          resolve: {
            params: function() {
              return {
                me: me,
                org: $scope.org,
                dates: dates,
                users: $scope.allUsers,
                businessWeek: businessWeek
              };
            },
            workPeriods: ['WorkPeriodStore', function(WorkPeriodStore) {
              return WorkPeriodStore.getWorkPeriodsBetween(workPeriodTimeframe.start, workPeriodTimeframe.end);
            }],
            initialProjections: ['Projections', function(Projections) {
              return Projections.getAll({
                organization_id: $scope.org.id,
                start_date: dates[0].format('YYYY-MM-DD'),
                end_date: dates[6].format('YYYY-MM-DD'),
                active: true
              })
            }]
          }
        });
        modalInstance.result.then(function(result) {
            console.log('closed week in review modal with result' + result);
          },
          function(reason) {
            console.log('dismissed explanation with reason ' + reason);
          });

        InternalAnalyticsService.captureAnalytic('openReviewWeek', {
          _v: 1,
          _d: {
            weekStartDate: dates[0].format('YYYY-MM-DD'),
            weekEndDate: dates[6].format('YYYY-MM-DD'),
            currentDate: $scope.currentDate.format('YYYY-MM-DD')
          }
        });

      }

    };


    $scope.openEmployeeListModal = function() {
      if (!$scope.userDataLoaded) {
        $scope.modalOpenWaitFlags.review = true;
      } else {
        var workPeriodTimeframe = TimeService.getWeekTwixFromMoment($scope.currentDate, 1, 0, true);

        // don't add dayStartHour
        var calendarWeek = TimeService.getWeekTwixFromMoment($scope.currentDate, 0, 0, false);

        // with dayStartHour
        var businessWeek = TimeService.getWeekTwixFromMoment($scope.currentDate, 0, 0, true);

        // dates with dayStartHour
        var dates = lodash.range(7).map(function(num) {
          return moment(businessWeek.start).add(num, 'days');
        });

        var modalInstance = $uibModal.open({
          size: 'full',
          keyboard: false,
          backdrop: 'static',
          templateUrl: 'views/mwpEmployeeListModal.html',
          controller: 'MwpEmployeeListCtrl',
          resolve: {
            params: function() {
              return {
                me: me,
                org: $scope.org,
                dates: dates,
                users: $scope.allUsers,
                businessWeek: businessWeek,
                calendarWeek: calendarWeek
              };
            },
            workPeriods: ['WorkPeriodStore', function(WorkPeriodStore) {
              return WorkPeriodStore.getWorkPeriodsBetween(workPeriodTimeframe.start, workPeriodTimeframe.end);
            }]
          }
        });
        modalInstance.result.then(function(result) {
            console.log('closed week in review modal with result' + result);
          },
          function(reason) {
            console.log('dismissed explanation with reason ' + reason);
          });

        InternalAnalyticsService.captureAnalytic('openAllocationsOfHours', {
          _v: 1,
          _d: {
            weekStartDate: calendarWeek.start.format('YYYY-MM-DD'),
            weekEndDate: calendarWeek.end.format('YYYY-MM-DD'),
            currentDate: $scope.currentDate.format('YYYY-MM-DD')
          }
        });
      }
    };


    $scope.toggleDepartmentCollapsed = function(dept) {
      if (dept._collapsed) {
        dept._collapsed = false;
      } else {
        dept._collapsed = true;
      }
      Session.setManageWorkPeriodsCollapseDeptState(dept.id, dept._collapsed);
      $scope.$broadcast('departmentCollapseStateChange');
    };

    $scope.changePositionCollapseState = function(state) {
      state = state === 'true' || state === true;

      lodash.forEach($scope.allDepartments, function(dept) {
        lodash.forEach(dept.positions, function(pos) {
          if (pos._collapsed !== state) {
              pos._collapsed = state;
              $scope.$broadcast('redrawPositionBar', {positionId: pos.id});
          }
        });
      });

      mwpCollapseStream.push('all', true);
    };

    $scope.togglePositionCollapse = function(pos) {
      pos.toggleCollapsedProperty();
      mwpCollapseStream.push('position', pos.id);
    };

    $scope.$on('sa:changePositionCollapseState', function(event, state) {
      $scope.changePositionCollapseState(state);
    });

    $scope.openQuickAddShiftsModal = function() {
      var modalInstance = $uibModal.open({
        size: 'md',
        keyboard: false,
        backdrop: 'static',
        templateUrl: 'views/quickAddShiftsModal.html',
        controller: 'QuickAddShiftsModalCtrl',
        resolve: {
          params: function() {
            return {
              me: me,
              org: $scope.org,
              allPositions: $scope.allPositions,
              currentDate: $scope.currentDate
            };
          }
        }
      });

      modalInstance.result.then(function(result) {
            //console.log('closed openQuickAddShiftsModal');
            //console.log(result);
            $scope.forceUpdate = !$scope.forceUpdate;
          },
          function(reason) {
            ShepherdTourService.triggerEvent('quickAddClosed', 1000);
            console.log('dismissed explanation with reason ' + reason);
          });
    };

    $timeout(function() {
      $rootScope.$broadcast('sa:updatedOrgData', $scope.org);
      $rootScope.$broadcast('sa:manageWorkPeriod:WorkPeriodStoreUpdated', $scope.currentDate);
      //$scope.loadAllDone = true;
    }, 100);

    $scope.getSmartSchedulingTooltipText = function() {
      if ($scope.smartSchedulingAvailable && !$scope.activeTemplateCompletelyFilled && $scope.userDataLoaded) {
        return 'Fill all shifts quickly';
      } else if (!$scope.smartSchedulingAvailable) {
        return 'In the past';
      } else {
        return 'No shifts to fill yet';
      }
    };

    $scope.$on('sa:manageWorkPeriod:getUser', function(event, data) {
      var usr = lodash.find($scope.allUsers, {id: data.userId});
      data.fn(usr);
      event.stopPropagation();
    });

    $scope.$on('sa:manageWorkPeriod:getUserWithAvailability', function(event, data) {
      if ($scope.compositeAvailabilityLoaded) {
        var usr = lodash.find($scope.allUsers, {id: data.userId});
        data.fn(usr);
        event.stopPropagation();
      } else {
        data.fn(undefined);
      }
    });

    $scope.$on('sa:manageWorkPeriod:editShiftStartedInit', function(event, shiftId) {
      $scope.$broadcast('sa:manageWorkPeriod:editShiftStarted', shiftId);
    });

    // check to see if anything should be highlighted
    //console.log('currentHighlight', MWPHighlightService.getCurrentHighlight());
    if (MWPHighlightService.getCurrentHighlight()) {
      $scope.$broadcast('sa:manageWorkPeriod:highlightWorkPeriods');

      $timeout(function() {
        MWPHighlightService.pullCurrentHighlight();
      }, 7000);
    }

    $scope.$on('sa:manageWorkPeriod:startHighlightWorkPeriods', function(event, data) {
      //console.log('$on ', event.name);
      $scope.$broadcast('sa:manageWorkPeriod:highlightWorkPeriods');

      $timeout(function() {
        MWPHighlightService.pullCurrentHighlight();
      }, 7000);
    });

    $scope.$on('sa:manageWorkPeriod:openSetProjections', function(event) {
      if (!($uibModalStack.getTop() && $uibModalStack.getTop().templateUrl === 'views/projectionsModal.html')) {
        $scope.openProjectionsModal();
      }
    });

    $scope.$on('sa:manageWorkPeriod:openWeekReviewModal', function(event) {
      if (!($uibModalStack.getTop() && $uibModalStack.getTop().templateUrl === 'views/reviewWeekScheduleModal.html')) {
        $scope.openWeekReviewModal();
      }
    });

    $scope.$on('sa:manageWorkPeriod:openEmployeeListModal', function(event) {
      if (!($uibModalStack.getTop() && $uibModalStack.getTop().templateUrl === 'views/mwpEmployeeListModal.html')) {
        $scope.openEmployeeListModal();
      }
    });

    $scope.tapHoldShiftItems = [
      {
        text: 'Add Shifts',
        fn: $scope.openQuickAddShiftsModal
      },
      {
        text: 'Clear Shifts',
        fn: function() {
          $scope.openClearDayModal();
        }
      }
    ];

    $scope.$watch('activeShiftTemplate', function (newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        GlobalRxFeed.push('custom-event', 'activeTemplateChanged')
      }
    })

//      $scope.openQuickAddShiftsModal();
//     $timeout(function() {
//       $scope.state.selectedTemplate = lodash.last($scope.allShiftTemplates);
//       $timeout($scope.openSmartSchedulingTwo, 500);
//     }, 4500);

//   uncomment line below to have modal pop up when page loads
//    $timeout(function() {
//      $scope.openCreateWorkPeriodDialog($scope.allPositions[4]);
//    }, 3000);

  });
